var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { usePositionStyle } from '@antv/xflow';
export var usePanelLyaoutStyle = function (config, noSchema) {
    return {
        bodyStyle: usePositionStyle(__assign({ left: 0, right: 0, top: 0, bottom: 0 }, config.bodyPosition)),
    };
};
